<template>
  <div>
    <div v-if="dataList" :style="{marginTop:navbarHeight+'px',height:contentHeight}" class="mb50 bbt1EF scrollWrap">
      <van-row class="padAll20 bgfff bb8" type="flex" align="center" v-for="(item) in dataList" :key="item.Id">
        <van-col :span="item.Enabled?22:24" class="text-left" @click="()=>{item.checked = !item.checked;changeCheckbox(item.checked,item)}">
          <van-row class="mb15">
            <van-col :span="!item.Enabled?20:24">
              <div class="fw700 f40" :class="!item.Enabled?'c999':'c222'">{{item.CustomerName}}</div>
              <!-- <div class="f12 fw500 mt4" :class="!item.Enabled?'c999':'c777'">（四川康贝大药房连锁有限公司）</div> -->
            </van-col>
            <van-col :span="4" v-if="!item.Enabled" class="text-right">
              <van-tag color="#D6D6D6" class="height18">已冻结</van-tag>
            </van-col>
          </van-row>
          <div class="flex align-items-center">
            <span class="f14 mr10" :class="!item.Enabled?'c999':'c222'">所属业务线</span>
            <van-tag :color="!item.Enabled?'#D6D6D6':'#0F6EEA'" style="padding-top:1px; margin-top:2px;"
              v-for="line in item.BusinessLineList" :key="line" class="height16 mr10 f12">
              {{line}}</van-tag>
          </div>
          <div class="mt5 f14" :class="item.Enabled?'c999':'c777'">{{item.AreaName}} {{setStreet(item.Address,item.AreaName)}}</div>
        </van-col>
        <van-col :span="2" v-if="item.Enabled">
          <van-checkbox v-model="item.checked" @change="changeCheckbox($event,item)" checked-color="#0F6EEA" icon-size="25px" />
        </van-col>
      </van-row>
    </div>
    <van-goods-action :style="{paddingBottom:paddingBottom+'px'}">
      <van-goods-action-button text="确定" color="#0F6EEA" @click="onClickButton" :loading="loading"
        :disabled="!selected||!selected.checked||!selected.Enabled" />
    </van-goods-action>
  </div>
</template>
<script>
  import { BaseMixin } from "../mixins/BaseMixin.js";
  export default {
    name: "MyStore",
    noNeedAuth: true,
    mixins: [BaseMixin],
    data() {
      return {
        selected: null,
        isFromLogin: false,
        loading: false,
        redirect: 'Login',
        backRedirect: 'Login',
        paddingBottom: 0,
        dataList: [],
        url: {
          customers: "/api_customers/Customer/GetByContact",
          selectCustomer: "/clientapi_contacts/Contacts/SelectCustomer"
        },
        offsetTop: 0,
        navbarHeight: 0,
        contentHeight: 0
      };
    },
    created() {
      this.paddingBottom = 0;
      this.isFromLogin = this.$route.params.isFromLogin;
      if (this.isFromLogin) {
        this.dataList = this.$route.params.customers;
      }
      const redirect = this.$route.params.redirect;
      if (redirect) {
        this.redirect = redirect;
      } else {
        this.redirect = 'home/Home';
      }

      const cusId = this.auth.getCustomerId();
      if (cusId) {
        this.backRedirect = 'home/Home';
      } else {
        this.backRedirect = 'Login';
      }
    },
    mounted() {
      this.offsetTop = 0;
      this.navbarHeight = 0;
      this.contentHeight = this.getHeight();

      if (!this.isFromLogin) this.loadStore();
    },
    methods: {
      getHeight() {
        var bottom = 0;
        return (window.innerHeight - bottom - 48 - 46 - this.offsetTop) + "px";
      },
      //加载店铺数据
      async loadStore() {
        this.$hys.openLoading();
        let res = await this.getAction(this.url.customers);
        this.$hys.clearLoading();
        if (!res.IsSuccess) {
          this.$toast({ position: "bottom", message: res.Msg });
          return;
        }
        res.Data.forEach(w => {
          w.checked = false;
          if (this.auth.getCustomerId() && w.Id == this.auth.getCustomerId()) {
            w.checked = true;
            this.selected = w;
          }
        });
        let customers = res.Data;
        if (!customers || customers.length == 0) {
          this.$toast({
            position: "bottom",
            message: this.lang.Login.ErrorCustomerTip
          });
          return;
        }
        if (customers.length == 1 && this.isFromLogin) {
          await this.onConfirmCustomer(customers[0]);
          return;
        }
        this.dataList = customers;
      },
      //确定数据选择
      async onConfirmCustomer(customer) {
        let res = await this.getAction(this.url.selectCustomer, {
          customerid: customer.Id
        });
        this.loading = false
        if (!res.IsSuccess) {
          this.$toast({ position: "bottom", message: res.Msg });
          return;
        }
        this.auth.setCustomerId(customer.Id);
        this.auth.setCustomerName(customer.CustomerName);
        this.auth.setContactsId(customer.ContactsId);
        this.auth.setCustomerType(customer.CustomerType);
        //只能回到首页
        this.$router.push('/');
        // this._goHome(this.redirect == "Home" ? 0 : 4, {}, null, true, true);
      },
      changeCheckbox(e, item) {
        if (e) {
          let nocur = this.dataList.filter(
            tag => tag.Id != item.Id && tag.checked
          );
          nocur.forEach(item => {
            item.checked = false;
          });
          this.selected = item;
        } else {
          if (this.selected == item) this.selected = null;
        }
      },
      onClickButton() {
        this.loading = true;
        this.onConfirmCustomer(this.selected);
      },
      onBack() {
        this._back();
      },
      setStreet(address, areaName) {
        if (address && areaName && address.indexOf(areaName) != -1) {
          return address.substring(address.indexOf(areaName) + areaName.length, address.length)
        } else {
          return address
        }
      }
    },
    beforeMount() {
      
    }
  };
</script>
<style lang="less" scoped>
  /deep/.van-nav-bar__title {
    font-weight: bold !important;
  }

  /deep/ .van-goods-action-button {
    font-weight: bold;
  }

  .van-goods-action {
    height: auto;
  }

  .van-goods-action-button {
    height: 48px;
    font-size: 16px;
  }

  .van-checkbox {
    justify-content: flex-end;
  }

  /deep/.default_nav_bar.van-hairline--bottom::after {
    border-bottom-width: 1px;
  }
</style>